import { translateKey } from '../translate';

export function getServiceProviderTitle(serviceProvider: {
    isAnalyst?: boolean;
    isBiometrician?: boolean;
    isGrader?: boolean;
}) {
    if (serviceProvider.isBiometrician && serviceProvider.isGrader) {
        return `(${translateKey('serviceProvider.biometrician')}, ${translateKey(
            'serviceProvider.grader'
        )})`.toLowerCase();
    }
    if (serviceProvider.isBiometrician) {
        return `(${translateKey('serviceProvider.biometrician').toLowerCase()})`;
    }
    if (serviceProvider.isGrader) {
        return `(${translateKey('serviceProvider.grader').toLowerCase()})`;
    }
    if (serviceProvider.isAnalyst) {
        return `(${translateKey('serviceProvider.analyst').toLowerCase()})`;
    }

    return '';
}
